import { Text, View, StyleSheet, Font } from '@react-pdf/renderer';
import { Fragment, useContext } from 'react';
import { GlobalContext } from '../../context/Provider';
import { orderInvoice } from '../../pages/order/orderInterface';
import { LanguageKeys } from '../../context/providerInterface';

Font.register({
    family: 'bold',
    src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-bold-webfont.ttf",
    fontWeight: 'bold'
});

Font.register({
    family: 'italic',
    src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-italic-webfont.ttf",
});

Font.register({
    family: 'italic-regular',
    src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-italic-webfont.ttf",
});

const styles = StyleSheet.create({
    titleContainer: {
        marginTop: 10,
        marginBottom: 30,
    },
    reportTitle: {
        color: '#000',
        fontSize: 14,
        textAlign: 'center',
        textTransform: 'capitalize',
        fontFamily: 'bold'
    },
    container: {
        flexDirection: 'row',
    },
    font10: {
        fontSize: 10,
        color: '#000'
    }
});

type dataType = {
    dataHolder: orderInvoice
}

const InvoiceHeader = ({ dataHolder }: dataType) => {

    const { authState, language_data } = useContext(GlobalContext);

    // Translation helper
    const t = (key: keyof LanguageKeys, fallback: string) =>
        language_data?.[authState?.lang]?.[key] || fallback;

    return (
        <Fragment>

            {/* Title */}
            <View style={styles.titleContainer}>
                <Text style={styles.reportTitle}>
                    {t('common_tax', 'Tax')} {t('common_invoice', 'Invoice')}
                </Text>
            </View>

            <View style={styles.container}>

                {/* Sold By */}
                <View style={{ width: '80%' }}>

                    <Text style={[styles.font10, { fontFamily: 'bold', marginBottom: 10 }]}>
                        {t('common_sold', 'Sold')} {t('common_by', 'By')}:
                        {dataHolder?.seller_id?.company || t('common_not_available', 'N/A')}
                    </Text>

                    <View style={styles.container}>
                        <Text style={{ width: '12%', fontFamily: 'italic' }}>
                            {t('common_ship', 'Ship')}-{t('common_from', 'From')} {t('common_address', 'Address')}:
                        </Text>

                        <Text style={{ width: '88%', fontFamily: 'italic-regular' }}>
                            {dataHolder?.seller_id?.full_address || t('common_not_available', 'N/A')}
                        </Text>
                    </View>

                </View>

                {/* Invoice Details */}
                <View style={{ width: '20%' }}>

                    <View
                        style={[
                            styles.font10,
                            styles.container,
                            { width: '100%', justifyContent: 'flex-end', marginBottom: 10 }
                        ]}
                    >
                        <Text style={{ fontFamily: 'bold', marginRight: 5, textAlign: 'right' }}>
                            {t('common_invoice', 'Invoice')} {t('common_number', 'Number')}
                        </Text>

                        <Text style={{ textAlign: 'right' }}>
                            {dataHolder?.invoice_id || t('common_not_available', 'N/A')}
                        </Text>
                    </View>

                    <View
                        style={[
                            styles.container,
                            { width: '100%', justifyContent: 'flex-end' }
                        ]}
                    >
                        <Text style={{ fontFamily: 'bold', marginRight: 5, textAlign: 'right' }}>
                            {t('common_tax', 'Tax')} {t('common_number', 'Number')} -
                        </Text>

                        <Text style={{ textAlign: 'right' }}>
                            {dataHolder?.tax_no || t('common_not_available', 'N/A')}
                        </Text>
                    </View>

                </View>

            </View>

            <View style={{ borderBottom: '1px solid #000', margin: '15px 0 10px' }} />

        </Fragment>
    );
};

export default InvoiceHeader;